export default function Spinner() {
  return (
    <div className="spinner">
      <svg width="24" height="24">
        <use href="/icons.svg#icon-loader" />
      </svg>
    </div>
  );
}
